var React = require('react');

function List (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"199","fill":"white","key":0}),React.createElement("rect",{"x":"16","y":"16","width":"124","height":"24","fill":"#D8D8D8","key":1}),React.createElement("rect",{"x":"16","y":"112","width":"124","height":"24","fill":"#D8D8D8","key":2}),React.createElement("rect",{"width":"288","height":"48","transform":"translate(0 52)","fill":"white","key":3}),React.createElement("rect",{"x":"16","y":"64","width":"124","height":"24","fill":"#D8D8D8","key":4}),React.createElement("rect",{"width":"288","height":"48","transform":"translate(0 148)","fill":"white","key":5}),React.createElement("rect",{"x":"16","y":"160","width":"124","height":"24","fill":"#D8D8D8","key":6})]);
}

List.defaultProps = {"width":"288","height":"199","viewBox":"0 0 288 199","fill":"none"};

module.exports = List;

List.default = List;
